/**
 * タブ（TAB）モジュール
 */
export const TAB = {
  init() {
    const tab = document.querySelector('.c-top-tab')
    const activeClass = 'is-active'

    if (tab) {
      const buttons = tab.querySelectorAll('.c-top-tab__button')
      const contents = tab.querySelectorAll('.c-top-tab__content')

      buttons.forEach(button => {
        button.addEventListener('click', () => {
          const target = button.dataset.tab

          buttons.forEach(btn => btn.classList.remove(activeClass))
          button.classList.add(activeClass)

          contents.forEach(content => {
            content.classList.toggle(activeClass, content.id === target)
          })
        })
      })
    }
  },
}
